import { render, staticRenderFns } from "./modalSeguroDesemprego.vue?vue&type=template&id=f2e3c04c&scoped=true&"
import script from "./modalSeguroDesemprego.vue?vue&type=script&lang=js&"
export * from "./modalSeguroDesemprego.vue?vue&type=script&lang=js&"
import style0 from "./modalSeguroDesemprego.vue?vue&type=style&index=0&id=f2e3c04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e3c04c",
  null
  
)

export default component.exports